export default "__VITE_ASSET__CZdrTPT2__"